import * as recall from '@otter-ai/recall-client';
import { MINUTE_MS } from '@/constants/time';

export type GalleryTemplatePreviewsQuery = {
  readonly queryKey: ['gallery-templates'];
  readonly queryFn: () => Promise<recall.GalleryTemplatePreview[] | undefined>;
  readonly staleTime: number;
};

/**
 * Query creator for fetching gallery template previews
 *
 * @example
 * ```tsx
 * const { data: galleryTemplates } = useQuery(galleryTemplatePreviewsQueryCreator());
 *
 * // with queryClient
 * const galleryTemplates = await queryClient.fetchQuery(galleryTemplatePreviewsQueryCreator());
 * queryClient.invalidateQueries(galleryTemplatePreviewsQueryCreator());
 * queryClient.setQueryData(galleryTemplatePreviewsQueryCreator().queryKey, newGalleryTemplatesData);
 * ```
 *
 * @param additionalOptions Additional options that can be passed to useQuery
 */
export function galleryTemplatePreviewsQueryCreator(): GalleryTemplatePreviewsQuery {
  return {
    staleTime: 10 * MINUTE_MS,
    queryKey: ['gallery-templates'],
    queryFn: async () => {
      const response = await recall.listGalleryTemplatePreviews();
      if (response.error) {
        throw response.error;
      }
      return response.data?.gallery_template_previews;
    },
  };
}
